import { Box, MenuItem } from "@mui/material"
import IconSeeker from "./IconSeeker"
import LoadingIconSeeker from "./LoadingIconSeeker"

export default function PopoverSeekerItem({ icon, iconWeight = "light", label, onClick, isLoading = false }) {
    return (
        <MenuItem onClick={onClick} sx={{ color: "text.disabled" }} disabled={isLoading}>
            {isLoading ? <LoadingIconSeeker /> : icon && <IconSeeker icon={icon} iconWeight={iconWeight} />}
            <Box component="span" sx={{ ml: 1 }}>{label}</Box>
        </MenuItem>
    )
}
